import { getSameDay } from 'helpers/Utils';
import CalendarIcon from 'mdi-react/CalendarIcon';
import React from 'react';
import { FormattedTime } from 'react-intl';

type FormattedEventCourseTimeProps = {
  startTime: Date;
  endTime?: Date;
  displayIcon?: boolean;
  iconColor?: string;
  iconClassName?: string;
  textClassName?: string;
};

const FormattedEventCourseTime = ({
  startTime,
  endTime,
  displayIcon,
  iconClassName,
  textClassName,
  iconColor,
}: FormattedEventCourseTimeProps): React.ReactElement => {
  return (
    <span className="d-flex mt-1">
      {displayIcon && (
        <>
          <CalendarIcon className={`mr-1 ${iconClassName}`} color={iconColor} />
          &nbsp;
        </>
      )}
      <span className={`${textClassName}`}>
        <FormattedTime value={startTime} year="numeric" month="short" day="2-digit" />
        { /* show end time in case it is provided  */}
        {
          endTime &&
          <>
            &nbsp;&ndash;&nbsp;
            {getSameDay(startTime, endTime) ? (
              <>
                <FormattedTime value={endTime} />
              </>
            ) : (
              <>
                <FormattedTime value={endTime} year="numeric" month="short" day="2-digit" />
              </>
            )}
          </>
        }
      </span>
    </span >
  );
};

export default FormattedEventCourseTime;
